import { createSlice } from '@reduxjs/toolkit';
import ProbeApiService from '../provider/redux/query/probe.service';
const initialState = {
  bluetoothClassicProbes: [],
  totalRecords: 0,
  page: 1,
};

const bluetoothClasicProbeSlice = createSlice({
  name: 'bluetoothClassicProbes',
  initialState,
  extraReducers: builder => {
    builder
      .addMatcher(ProbeApiService.endpoints.getBluetoothClassicProbes.matchFulfilled, (state, action) => {
        // console.log('================================');
        // console.log('getBluetoothClassicProbes [matchFulfilled] =>', action.payload);
        // console.log('================================');
        const { totalRecords, bluetoothClassicProbes } = action.payload.data;
        state.bluetoothClassicProbes = bluetoothClassicProbes;
        state.totalRecords = totalRecords;
        state.loading = false;
      })
      .addMatcher(ProbeApiService.endpoints.getBluetoothClassicProbes.matchPending, state => {
        state.loading = true;
      })
      .addMatcher(ProbeApiService.endpoints.getBluetoothClassicProbes.matchRejected, state => {
        state.loading = false;
      });
  },
});

export default bluetoothClasicProbeSlice;
